import { render } from "./HYchannel.vue?vue&type=template&id=397d8677&scoped=true"
import script from "./HYchannel.vue?vue&type=script&lang=js"
export * from "./HYchannel.vue?vue&type=script&lang=js"

import "./HYchannel.vue?vue&type=style&index=0&id=397d8677&lang=scss&scoped=true"
import "./HYchannel.vue?vue&type=style&index=1&id=397d8677&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-397d8677"]])

export default __exports__